import ExtendAnnouncement from '@/components/extend-announcement/index.vue';

export default {
  components: {
    ExtendAnnouncement
  },
  data () {
    return {
      extendDialogVisible: false,
      queryParams: {
        projectId: '',
        type: ''
      }
    };
  },
  methods: {
    // 申请延长公告
    applyExtendAnnouncement (projectId, type, isHistory) {
      this.extendDialogVisible = true;
      this.queryParams = {
        projectId,
        type,
        isHistory
      };
    }
  }
};
